import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StoreCounsel from 'pages/hq/hq/storeCounsel/StoreCounsel';
import JoinCounsel from 'pages/hq/hq/joinCounsel/JoinCounsel';
import SchoolLecture from 'pages/hq/hq/schoolLecture/SchoolLecture';
import AccountInfo from 'pages/hq/AccountInfo';
import BranchManage from 'pages/hq/branch/BranchManage';
import BranchRegion from 'pages/hq/branch/region/BranchRegion';

import HqBranchCloseReport from 'pages/hq/branch/close/HqBranchCloseReport';
import HqBranchCloseReportPerformance from 'pages/hq/branch/close/tabs/HqBranchCloseReportPerformance';
import HqBranchCloseReportClose from 'pages/hq/branch/close/tabs/HqBranchCloseReportClose';

import BoardClassCateAdd from 'pages/hq/board/class/BoardClassCateAdd';
import InitialProductOrder from 'pages/initial-product/InitialProductOrder';
import { URL_SPTP_CHECK_UP_MANAGE, URL_SPTP_INQUIRY, URL_SPTP_INQUIRY_DETAIL, URL_SPTP_MANAGE } from './SptpRoute';
import { URL_BOARD_BANNER, URL_BOARD_CLASS, URL_BOARD_CLASS_ADD, URL_BOARD_CLASS_CAT_ADD, URL_BOARD_CLASS_DETAIL, URL_BOARD_CLASS_EDIT, URL_BOARD_TASK, URL_BOARD_TASK_ADD, URL_BOARD_TASK_DETAIL, URL_BOARD_TASK_EDIT, URL_CUSTOMER_CENTER_FAQ, URL_CUSTOMER_CENTER_FAQ_ADD, URL_CUSTOMER_CENTER_FAQ_DETAIL, URL_CUSTOMER_CENTER_FAQ_EDIT, URL_CUSTOMER_CENTER_INQUIRY, URL_CUSTOMER_CENTER_INQUIRY_DETAIL, URL_CUSTOMER_CENTER_PRODUCT_FAQ, URL_TASK_FORM_ADD, URL_TASK_FORM_DETAIL, URL_TASK_FORM_EDIT, URL_TASK_FORM_MAIN } from './CommonRoute';
import { URL_INITIAL_PRODUCT, URL_INITIAL_PRODUCT_ORDER } from './InitialProductRoute';
import CustomerCenterInquiryDetail from 'pages/hq/customer-center/inquiry/CustomerCenterInquiryDetail';
import BoardTaskDetail from 'pages/hq/board/task/BoardTaskDetail';
import BoardTaskAdd from 'pages/hq/board/task/BoardTaskAdd';
import BoardTaskEdit from 'pages/hq/board/task/BoardTaskEdit';
import CustomerCenterFaqDetail from 'pages/hq/customer-center/faq/CustomerCenterFaqDetail';
import CustomerCenterFaqAdd from 'pages/hq/customer-center/faq/CustomerCenterFaqAdd';
import CustomerCenterFaqEdit from 'pages/hq/customer-center/faq/CustomerCenterFaqEdit';
import ShoppingBookList from 'pages/hq/shopping/book/ShoppingBookList';
import BoardClassEdit from 'pages/hq/board/class/BoardClassEdit';

const Home = React.lazy(() => import('pages/Home'));

const StoreCounselDetail = React.lazy(() => import('pages/hq/hq/storeCounsel/StoreCounselDetail'));
const StoreCounselAdd = React.lazy(() => import('pages/hq/hq/storeCounsel/StoreCounselAdd'));
const JoinCounselAdd = React.lazy(() => import('pages/hq/hq/joinCounsel/JoinCounselAdd'));
const JoinCounselDetail = React.lazy(() => import('pages/hq/hq/joinCounsel/JoinCounselDetail'));
const SchoolLectureTeacherAdd = React.lazy(() => import('pages/hq/hq/schoolLecture/SchoolLectureTeacherAdd'));
const SchoolTeacherDetail = React.lazy(() => import('pages/hq/hq/schoolLecture/SchoolTeacherDetail'));
const SchoolTeacherEdit = React.lazy(() => import('pages/hq/hq/schoolLecture/SchoolTeacherEdit'));
const Schedule = React.lazy(() => import('pages/hq/hq/schedule/Schedule'));

const BranchManageDetail = React.lazy(() => import('pages/hq/branch/BranchManageDetail'));
const BranchManageEdit = React.lazy(() => import('pages/hq/branch/BranchManageEdit'));
const BranchManageAdd = React.lazy(() => import('pages/hq/branch/BranchManageAdd'));

const SchoolManage = React.lazy(() => import('pages/hq/school/manage/SchoolManage'));
const SchoolManageDetail = React.lazy(() => import('pages/hq/school/manage/tabs/SchoolManageDetail'));
const SchoolManageEdit = React.lazy(() => import('pages/hq/school/manage/tabs/SchoolManageEdit'));
const SchoolManageAdd = React.lazy(() => import('pages/hq/school/add/SchoolManageAdd'));
const SchoolMember = React.lazy(()=> import('pages/hq/school/manage/member/SchoolMember'));
const HqSchoolClose = React.lazy(() => import('pages/hq/school/close/HqSchoolClose'));
const HqSchoolCloseDetail = React.lazy(() => import('pages/hq/school/close/HqSchoolCloseDetail'));

const MemberManage = React.lazy(() => import('pages/hq/member/MemberManage'));
const MemberManageEdit = React.lazy(() => import('pages/hq/member/MemberManageEdit'));
const MemberRecess = React.lazy(() => import('pages/hq/member/recess/MemberRecess'));
const MemberRecessEdit = React.lazy(() => import('pages/hq/member/recess/MemberRecessEdit'));
const MemberTransfer = React.lazy(() => import('pages/hq/member/transfer/MemberTransfer'));

const OrderBook = React.lazy(() => import('pages/hq/order/book/OrderBook'));
const OrderProduct = React.lazy(() => import('pages/hq/order/product/OrderProduct'));
const OrderBookRefund = React.lazy(() => import('pages/hq/order/bookRefund/OrderBookRefund'));
const OrderProductRefund = React.lazy(() => import('pages/hq/order/productRefund/OrderProductRefund'));
const OrderCollect = React.lazy(() => import('pages/hq/order/collect/OrderCollect'));
const OrderChange = React.lazy(() => import('pages/hq/order/bookChange/OrderChange'));
const OrderMember = React.lazy(() => import('pages/hq/order/member/OrderMember'));
const OrderBookWatch = React.lazy(() => import('pages/hq/order/bookWatch/OrderBookWatch'));
const OrderBookWatchLog = React.lazy(() => import('pages/hq/order/bookWatchLog/OrderBookWatchLog'));
const OrderPointCart = React.lazy(() => import('pages/hq/order/pointCart/OrderPointCart'));
const OrderPointHistory = React.lazy(() => import('pages/hq/order/point/OrderPointHistory'));
const OrderSchool = React.lazy(() => import('pages/hq/order/school/OrderSchool'));
const OrderSchoolDetail = React.lazy(() => import('pages/hq/order/school/OrderSchoolDetail'));
const OrderDeliverySupport = React.lazy(() => import('pages/hq/order/deliverySupport/OrderDeliverySupport'));
const OrderLimit = React.lazy(() => import('pages/hq/order/limit/OrderLimit'));
const OrderNewsletter = React.lazy(() => import('pages/hq/order/letter/OrderNewsletter'));
const OrderRefundException = React.lazy(() => import('pages/hq/order/refundException/OrderRefundException'));
const OrderProgressCounsel = React.lazy(() => import('pages/hq/order/progress/OrderProgressCounsel'));
const OrderClassRequest = React.lazy(() => import('pages/hq/order/orderClassRequest/OrderClassRequest'));

const ShoppingBookAdd = React.lazy(() => import('pages/hq/shopping/bookAdd/ShoppingBookAdd'));
const ShoppingBookEdit = React.lazy(() => import('pages/hq/shopping/book/ShoppingBookEdit'));
const ShoppingBookCate = React.lazy(() => import('pages/hq/shopping/bookCate/ShoppingBookCate'));
const ShoppingProduct = React.lazy(() => import('pages/hq/shopping/product/ShoppingProduct'));
const ShoppingProductEdit = React.lazy(() => import('pages/hq/shopping/product/ShoppingProductEdit'));
const ShoppingProductAdd = React.lazy(() => import('pages/hq/shopping/product/ShoppingProductAdd'));
const ShoppingProductCate = React.lazy(() => import('pages/hq/shopping/productCate/ShoppingProductCate'));

const StockBook = React.lazy(() => import('pages/hq/stock/book/StockBook'));
const StockBookSaleDetail = React.lazy(() => import('pages/hq/stock/book/StockBookSaleDetail'));
const StockBookRefundDetail = React.lazy(() => import('pages/hq/stock/book/StockBookRefundDetail'));
const StockBookDamageBookDetail = React.lazy(() => import('pages/hq/stock/book/StockBookDamageBookDetail'));
const StockProduct = React.lazy(() => import('pages/hq/stock/product/StockProduct'));
const StockProductDetail = React.lazy(() => import('pages/hq/stock/product/StockProductDetail'));
const StockProductRefundDetail = React.lazy(() => import('pages/hq/stock/product/StockProductRefundDetail'));

const StatFull = React.lazy(() => import('pages/hq/stat/StatFull'));
const StatMember = React.lazy(() => import('pages/hq/stat/StatMember'));
const StatSchool = React.lazy(() => import('pages/hq/stat/StatSchool'));
const StatBook = React.lazy(() => import('pages/hq/stat/StatBook'));
const StatClass = React.lazy(() => import('pages/hq/stat/StatClass'));
const StatDemographic = React.lazy(() => import('pages/hq/stat/StatDemographic'));

const LogRequest = React.lazy(() => import('pages/hq/log/request/LogRequest'));
const LogSms = React.lazy(() => import('pages/hq/log/sms/LogSms'));
const LogOrderFirst = React.lazy(() => import('pages/hq/log/LogOrderFirst'));
const LogOrderFirstDetail = React.lazy(() => import('pages/hq/log/LogOrderFirstDetail'));
const LogOrderSecondDetail = React.lazy(() => import('pages/hq/log/LogOrderSecondDetail'));

const SptpManage = React.lazy(() => import('pages/hq/sptp/manage/SptpManageMain'));
const SptpCheckUpManage = React.lazy(() => import('pages/hq/sptp/checkup/SptpCheckUpManage'));
const SptpInquiry = React.lazy(() => import('pages/hq/sptp/inquiry/SptpInquiry'));
const SptpInquiryDetail = React.lazy(() => import('pages/hq/sptp/inquiry/SptpInquiryDetail'));

const BoardTaskList = React.lazy(() => import('pages/hq/board/task/BoardTaskList'));
const BoardClass = React.lazy(() => import('pages/hq/board/class/BoardClass'));
const BoardClassDetail = React.lazy(() => import('pages/hq/board/class/BoardClassDetail'));
const BoardClassAdd = React.lazy(() => import('pages/hq/board/class/BoardClassAdd'));
const BoardBanner = React.lazy(() => import('pages/hq/board/banner/BoardBanner'));

const TaskFormMain = React.lazy(() => import('pages/hq/task-form/TaskFormMain'));
const TaskFormDetail = React.lazy(() => import('pages/hq/task-form/TaskFormDetail'));
const TaskFormAdd = React.lazy(() => import('pages/hq/task-form/TaskFormAdd'));
const TaskFormEdit = React.lazy(() => import('pages/hq/task-form/TaskFormEdit'));

const CustomerCenterInquiry = React.lazy(() => import('pages/hq/customer-center/inquiry/CustomerCenterInquiryMain'));
const CustomerCenterFaq = React.lazy(() => import('pages/hq/customer-center/faq/CustomerCenterFaqMain'));
const CustomerCenterProductFaq = React.lazy(() => import('pages/hq/customer-center/product-faq/CustomerCenterProductFaqMain'));

const AdminManage = React.lazy(() => import('pages/hq/admin/AdminManage'));

const OrgManage = React.lazy(() => import('pages/hq/org/OrgManage'));

export const URL_ADMIN = '/admin';
/** 본사 */
export const URL_HQ = '/hq'; //본사
export const URL_HQ_DASHBOARD = '/dashboard'; //본사
export const URL_HQ_URL_ACCOUNT_INFO = '/account'; //내정보수정
export const URL_HQ_STORE_COUNSEL = '/store-counsel'; // 가맹 상담 관리
export const URL_HQ_STORE_COUNSEL_ADD = '/store-counsel/add'; // 가맹 상담 관리 등록
export const URL_HQ_STORE_COUNSEL_DETAIL = '/store-counsel/:no'; // 가맹 상담 관리
export const URL_HQ_JOIN_COUNSEL = '/join-counsel'; // 입회 상담 관리
export const URL_HQ_JOIN_COUNSEL_ADD = '/join-counsel/add'; // 입회 상담 관리 등록
export const URL_HQ_JOIN_COUNSEL_DETAIL = '/join-counsel/:no'; // 입회 상담 관리 상세
export const URL_HQ_SCHOOL_LECTURE = '/school-lecture'; // 교육원 강사 관리
export const URL_HQ_SCHOOL_LECTURE_ADD = '/school-lecture/add'; // 깅사 등록
export const URL_HQ_SCHOOL_LECTURE_EDIT = '/school-lecture/edit/:no'; // 깅사 수정
export const URL_HQ_SCHOOL_LECTURE_DETAIL = '/school-lecture/:no'; // 깅사 상세
export const URL_HQ_SCHOOL_CLASS = '/school-class'; // 클래스 관리
export const URL_HQ_SCHEDULE = '/schedule'; // 본사 일정관리

/** 지사 */
export const URL_ADMIN_BRANCH = '/branch'; //지사
export const URL_ADMIN_BRANCH_MANAGE = '/manage'; //지사 관리
export const URL_ADMIN_BRANCH_MANAGE_DETAIL = '/manage/infoSchool/:no'; //지사 관리 상세
export const URL_ADMIN_BRANCH_MANAGE_EDIT = '/manage/edit/:no'; // 지사 관리 수정
export const URL_ADMIN_BRANCH_MANAGE_ADD = '/manage/add'; // 지사 관리 생성
export const URL_BRANCH_REGION = '/region'; // 지사 지역 관리
export const URL_BRANCH_CLOSING_REPORT = '/closing-report'; // 지사 마감보고서
export const URL_BRANCH_CLOSING_REPORT_PERFORMANCE = '/closing-report/performance'; // 지사 마감보고서 상세-실적관리
export const URL_BRANCH_CLOSING_REPORT_CLOSE = '/closing-report/close'; // 지사 마감보고서 상세-마감보고서

/** 교육원 */
export const URL_ADMIN_SCHOOL = '/school'; //교육원
export const URL_ADMIN_SCHOOL_MANAGE = '/manage'; // 교육원 관리
export const URL_ADMIN_SCHOOL_MANAGE_DETAIL = '/manage/:no'; // 교육원 상세
export const URL_ADMIN_SCHOOL_MANAGE_EDIT = '/manage/edit/:no'; // 교육원 상세 수정
export const URL_ADMIN_SCHOOL_MANAGE_ADD = '/manage-add'; // 교육원 등록
export const URL_ADMIN_MEMBER = '/member/all/:no'; //교육원 회원리스트
export const URL_ADMIN_SCHOOL_CLOSING_REPORT = '/closing-report'; // 교육원 마감보고서
export const URL_ADMIN_SCHOOL_CLOSING_REPORT_DETAIL = '/closing-report/:yyyymm/:schoolIdx/:reportIdx'; // 교육원 마감보고서 상세

/** 회원관리 */
export const URL_MEMBER = '/member';
export const URL_MEMBER_MANAGE = '/manage'; // 회원 관리
export const URL_MEMBER_MANAGE_EDIT = '/manage/edit/:no'; // 회원 관리 수정
export const URL_MEMBER_RECESS = '/recess'; // 휴회 회원 관리
export const URL_MEMBER_RECESS_EDIT = '/recess/edit/:no'; // 휴회 회원 수정
export const URL_MEMBER_TRANSFER = '/transfer'; // 이동 회원 관리

/** 주문관리 */
export const URL_ORDER = '/order';
export const URL_ORDER_BOOK = '/book'; // 교재 주문관리
export const URL_ORDER_PRODUCT = '/product'; // 교재 물품관리
export const URL_ORDER_BOOK_REFUND = '/book-refund'; // 교재 환불관리
export const URL_ORDER_PRODUCT_REFUND = '/product-refund'; // 물품 환불관리
export const URL_ORDER_COLLECT = '/collect'; // 물품 환불관리
export const URL_ORDER_CHANGE = '/change'; // 주문수정/취소/교환요청
export const URL_ORDER_MEMBER = '/member'; // 회원별 교재 주문 내역
export const URL_ORDER_BOOK_WATCH = '/book-watch'; // 교재 주문 모니터링
export const URL_ORDER_BOOK_WATCH_LOG = '/book-watch-log'; // 교재 주문 모니터링 로그
export const URL_ORDER_POINT_CART = '/point-cart'; // 적립금 장바구니
export const URL_ORDER_POINT_HISTORY = '/point-history'; // 적립금 내역
export const URL_ORDER_SCHOOL = '/school'; // 교육원 주문현황
export const URL_ORDER_SCHOOL_DETAIL = '/school/:no'; // 교육원 주문현황 상세
export const URL_ORDER_DELIVERY_SUPPORT = '/delivery-support'; // 배송비 지원
export const URL_ORDER_LIMIT = '/limit'; // 주문제한 기한 설정
export const URL_ORDER_NEWSLETTER = '/newsletter'; // 소식지 기한 설정
export const URL_ORDER_REFUND_EXCEPTION = '/refund-exception'; // 환불요청 예외승인
export const URL_ORDER_PROGRESS_COUNSEL = '/progress-counsel'; // 진도 재설정 상담관리
export const URL_ORDER_CLASS_REQUEST = '/class-request'; //수업승인요청 관리

/** 쇼핑몰관리 */
export const URL_SHOPPING = '/shopping';
export const URL_SHOPPING_BOOK = '/book'; // 교재 목록
export const URL_SHOPPING_BOOK_ADD = '/book-add'; // 교재 등록
export const URL_SHOPPING_BOOK_EDIT = '/book/:no'; // 교재 등록
export const URL_SHOPPING_PRODUCT = '/product'; // 물품 목록
export const URL_SHOPPING_PRODUCT_EDIT = '/product/:no'; // 물품 상세
export const URL_SHOPPING_PRODUCT_ADD = '/product-add'; // 물품 등록
export const URL_SHOPPING_BOOK_CATE = '/book-cate'; // 교재 카테고리 관리
export const URL_SHOPPING_PRODUCT_CATE = '/product-cate'; // 물품 카테고리 관리

/** 재고관리 */
export const URL_STOCK = '/stock';
export const URL_STOCK_BOOK = '/book'; // 교재 재고관리
export const URL_STOCK_BOOK_SALE_DETAIL = '/book/sale/:no'; // 교재 재고관리 상세 - 판매
export const URL_STOCK_BOOK_REFUND_DETAIL = '/book/refund/:no'; // 교재 재고관리 상세 - 환불
export const URL_STOCK_BOOK_DAMAGEBOOK_DETAIL = '/book/damagebook/:no'; // 교재 재고관리 상세 - 파본
export const URL_STOCK_PRODUCT = '/product'; // 물품 재고관리
export const URL_STOCK_PRODUCT_SALE_DETAIL = '/product/:no'; // 물품 재고관리 상세
export const URL_STOCK_PRODUCT_REFUND_DETAIL = '/product/refund/:no'; // 물품 재고관리 상세 - 환불

/** 통계 */
export const URL_STAT = '/stat';
export const URL_STAT_FULL = '/full'; // 통계 전체
export const URL_STAT_MEMBER = '/member'; // 회원
export const URL_STAT_SCHOOL = '/school'; // 교육원
export const URL_STAT_BOOK = '/book'; // 교재매출
export const URL_STAT_CLASS = '/class'; // 수업승인 요청통계
export const URL_STAT_DEMOGRAPHIC = '/demographic'; // 지사별 인구수 설정

/** 로그관리 */
export const URL_LOG = '/log';
export const URL_LOG_REQUEST = '/request'; // 요청 로그
export const URL_LOG_SMS = '/sms'; // SMS 로그
export const URL_LOG_ORDER_FIRST = '/order-first'; // 초도물품 요청 로그
export const URL_LOG_ORDER_FIRST_DETAIL = '/order-first/detail/:no'; // 초도물품 요청 로그
export const URL_LOG_ORDER_SECOND_DETAIL = '/order-second/detail/:no'; // 초도물품 요청 로그

/** 업무서식 */
// export const URL_TASK_FORM = '/task-form';
// export const URL_TASK_FORM_MAIN = '/main'; // 서식
// export const URL_TASK_FORM_MAIN_ADD = '/main/add'; // 서식 추가
// export const URL_TASK_FORM_MAIN_DETAIL = '/main/detail/:no'; // 서식 상세
// export const URL_TASK_FORM_MAIN_EDIT = '/main/edit/:no'; // 서식 수정
// export const URL_TASK_FORM_HANDBOOK = '/handbook'; // 매뉴얼
// export const URL_TASK_FORM_HANDBOOK_ADD = '/handbook/add'; // 추가
// export const URL_TASK_FORM_HANDBOOK_DETAIL = '/handbook/detail/:no'; // 상세
// export const URL_TASK_FORM_HANDBOOK_EDIT = '/handbook/edit/:no'; // 수정

export const URL_TASK_FORM_DRAFT = '/draft'; // 표준시안
export const URL_TASK_FORM_DRAFT_ADD = '/draft/add'; // 추가
export const URL_TASK_FORM_DRAFT_DETAIL = '/draft/detail/:no'; // 상세
export const URL_TASK_FORM_DRAFT_EDIT = '/draft/edit/:no'; // 수정

export const URL_TASK_FORM_BRIEF = '/brief'; // 설명회&상담자료
export const URL_TASK_FORM_BRIEF_ADD = '/brief/add'; // 추가
export const URL_TASK_FORM_BRIEF_DETAIL = '/brief/detail/:no'; // 상세
export const URL_TASK_FORM_BRIEF_EDIT = '/brief/edit/:no'; // 수정

/** 관리자 계정관리 */
export const URL_ACCOUNT = '/account';
export const URL_ADMIN_MANAGE = '/manage'; // 관리자 게정 문의

/** 조직/인사관리 */
export const URL_ORG = '/org';
export const URL_ORG_MANAGE = '/manage'; // 조직관리

/**
 * 본사
 * @returns
 */
const AdminRoute = ({ common, setCommon }) => {
  return (
    <Routes>
      <Route path={URL_HQ_DASHBOARD} element={<Home common={common} />} />
      
      <Route path={URL_HQ_URL_ACCOUNT_INFO} element={<AccountInfo common={common} />} />

      {/* 본사 */}
      <Route path={URL_HQ + URL_HQ_STORE_COUNSEL} element={<StoreCounsel common={common} setCommon={setCommon} />} />
      <Route path={URL_HQ + URL_HQ_STORE_COUNSEL_ADD} element={<StoreCounselAdd common={common} />} />
      <Route path={URL_HQ + URL_HQ_STORE_COUNSEL_DETAIL} element={<StoreCounselDetail common={common} />} />
      <Route path={URL_HQ + URL_HQ_JOIN_COUNSEL} element={<JoinCounsel common={common} />} />
      <Route path={URL_HQ + URL_HQ_JOIN_COUNSEL_ADD} element={<JoinCounselAdd common={common} />} />
      <Route path={URL_HQ + URL_HQ_JOIN_COUNSEL_DETAIL} element={<JoinCounselDetail common={common} />} />
      <Route path={URL_HQ + URL_HQ_SCHOOL_LECTURE} element={<SchoolLecture common={common} />} />
      <Route path={URL_HQ + URL_HQ_SCHOOL_LECTURE_ADD} element={<SchoolLectureTeacherAdd common={common} />} />
      <Route path={URL_HQ + URL_HQ_SCHOOL_LECTURE_EDIT} element={<SchoolTeacherEdit common={common} />} />
      <Route path={URL_HQ + URL_HQ_SCHOOL_LECTURE_DETAIL} element={<SchoolTeacherDetail common={common} />} />
      <Route path={URL_HQ + URL_HQ_SCHEDULE} element={<Schedule common={common} />} />

      {/* 지사 */}
      <Route path={URL_ADMIN_BRANCH + URL_ADMIN_BRANCH_MANAGE} element={<BranchManage common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_ADMIN_BRANCH_MANAGE_DETAIL} element={<BranchManageDetail common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_ADMIN_BRANCH_MANAGE_EDIT} element={<BranchManageEdit common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_ADMIN_BRANCH_MANAGE_ADD} element={<BranchManageAdd common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_BRANCH_REGION} element={<BranchRegion common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_BRANCH_CLOSING_REPORT} element={<HqBranchCloseReport common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_BRANCH_CLOSING_REPORT_PERFORMANCE} element={<HqBranchCloseReportPerformance common={common} />} />
      <Route path={URL_ADMIN_BRANCH + URL_BRANCH_CLOSING_REPORT_CLOSE} element={<HqBranchCloseReportClose common={common} />} />

      {/* 교육원 */}
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_SCHOOL_MANAGE} element={<SchoolManage common={common} />} />
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_SCHOOL_MANAGE_DETAIL} element={<SchoolManageDetail common={common} />} />
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_SCHOOL_MANAGE_EDIT} element={<SchoolManageEdit common={common} />} />
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_SCHOOL_MANAGE_ADD} element={<SchoolManageAdd common={common} />} />
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_MEMBER} element={<SchoolMember common={common} />} />
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_SCHOOL_CLOSING_REPORT} element={<HqSchoolClose common={common} />} />
      <Route path={URL_ADMIN_SCHOOL + URL_ADMIN_SCHOOL_CLOSING_REPORT_DETAIL} element={<HqSchoolCloseDetail common={common} />} />

      {/* 회원관리 */}
      <Route path={URL_MEMBER + URL_MEMBER_MANAGE} element={<MemberManage common={common} />} />
      <Route path={URL_MEMBER + URL_MEMBER_MANAGE_EDIT} element={<MemberManageEdit common={common} />} />
      <Route path={URL_MEMBER + URL_MEMBER_RECESS} element={<MemberRecess common={common} />} />
      <Route path={URL_MEMBER + URL_MEMBER_RECESS_EDIT} element={<MemberRecessEdit common={common} />} />
      <Route path={URL_MEMBER + URL_MEMBER_TRANSFER} element={<MemberTransfer common={common} />} />

      {/* 주문관리 */}
      <Route path={URL_ORDER + URL_ORDER_BOOK} element={<OrderBook common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_BOOK_REFUND} element={<OrderBookRefund common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_PRODUCT} element={<OrderProduct common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_PRODUCT_REFUND} element={<OrderProductRefund common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_COLLECT} element={<OrderCollect common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_CHANGE} element={<OrderChange common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_MEMBER} element={<OrderMember common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_BOOK_WATCH} element={<OrderBookWatch common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_BOOK_WATCH_LOG} element={<OrderBookWatchLog common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_CLASS_REQUEST} element={<OrderClassRequest common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_POINT_HISTORY} element={<OrderPointHistory common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_SCHOOL} element={<OrderSchool common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_POINT_CART} element={<OrderPointCart common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_SCHOOL_DETAIL} element={<OrderSchoolDetail common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_DELIVERY_SUPPORT} element={<OrderDeliverySupport common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_LIMIT} element={<OrderLimit common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_NEWSLETTER} element={<OrderNewsletter common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_REFUND_EXCEPTION} element={<OrderRefundException common={common} />} />
      <Route path={URL_ORDER + URL_ORDER_PROGRESS_COUNSEL} element={<OrderProgressCounsel common={common} />} />

      {/* 쇼핑몰관리 */}
      <Route path={URL_SHOPPING + URL_SHOPPING_BOOK} element={<ShoppingBookList common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_BOOK_ADD} element={<ShoppingBookAdd common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_BOOK_EDIT} element={<ShoppingBookEdit common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_BOOK_CATE} element={<ShoppingBookCate common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_PRODUCT} element={<ShoppingProduct common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_PRODUCT_EDIT} element={<ShoppingProductEdit common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_PRODUCT_ADD} element={<ShoppingProductAdd common={common} />} />
      <Route path={URL_SHOPPING + URL_SHOPPING_PRODUCT_CATE} element={<ShoppingProductCate common={common} />} />

      {/* 초도물품관리 */}
      <Route path={URL_INITIAL_PRODUCT + URL_INITIAL_PRODUCT_ORDER} element={<InitialProductOrder common={common} />} />

      {/* 재고관리 */}
      <Route path={URL_STOCK + URL_STOCK_BOOK} element={<StockBook common={common} />} />
      <Route path={URL_STOCK + URL_STOCK_BOOK_SALE_DETAIL} element={<StockBookSaleDetail common={common} />} />
      <Route path={URL_STOCK + URL_STOCK_BOOK_REFUND_DETAIL} element={<StockBookRefundDetail common={common} />} />
      <Route path={URL_STOCK + URL_STOCK_BOOK_DAMAGEBOOK_DETAIL} element={<StockBookDamageBookDetail common={common} />} />
      <Route path={URL_STOCK + URL_STOCK_PRODUCT} element={<StockProduct common={common} />} />
      <Route path={URL_STOCK + URL_STOCK_PRODUCT_SALE_DETAIL} element={<StockProductDetail common={common} />} />
      <Route path={URL_STOCK + URL_STOCK_PRODUCT_REFUND_DETAIL} element={<StockProductRefundDetail common={common} />} />

      {/* 통계 */}
      <Route path={URL_STAT + URL_STAT_FULL} element={<StatFull common={common} />} />
      <Route path={URL_STAT + URL_STAT_MEMBER} element={<StatMember common={common} />} />
      <Route path={URL_STAT + URL_STAT_SCHOOL} element={<StatSchool common={common} />} />
      <Route path={URL_STAT + URL_STAT_BOOK} element={<StatBook common={common} />} />
      <Route path={URL_STAT + URL_STAT_CLASS} element={<StatClass common={common} />} />
      <Route path={URL_STAT + URL_STAT_DEMOGRAPHIC} element={<StatDemographic common={common} />} />

      {/* 로그관리 */}
      <Route path={URL_LOG + URL_LOG_REQUEST} element={<LogRequest common={common} />} />
      <Route path={URL_LOG + URL_LOG_SMS} element={<LogSms common={common} />} />
      <Route path={URL_LOG + URL_LOG_ORDER_FIRST} element={<LogOrderFirst common={common} />} />
      <Route path={URL_LOG + URL_LOG_ORDER_FIRST_DETAIL} element={<LogOrderFirstDetail common={common} />} />
      <Route path={URL_LOG + URL_LOG_ORDER_SECOND_DETAIL} element={<LogOrderSecondDetail common={common} />} />

      {/* SPTP */}
      <Route path={URL_SPTP_MANAGE} element={<SptpManage common={common} />} />
      <Route path={URL_SPTP_CHECK_UP_MANAGE} element={<SptpCheckUpManage common={common} />} />
      <Route path={URL_SPTP_INQUIRY} element={<SptpInquiry common={common} />} />
      <Route path={URL_SPTP_INQUIRY_DETAIL} element={<SptpInquiryDetail common={common} />} />

      {/* 게시판 */}
      <Route path={URL_BOARD_TASK} element={<BoardTaskList common={common} />} />
      <Route path={URL_BOARD_TASK_DETAIL} element={<BoardTaskDetail common={common} />} />
      <Route path={URL_BOARD_TASK_ADD} element={<BoardTaskAdd common={common} />} />
      <Route path={URL_BOARD_TASK_EDIT} element={<BoardTaskEdit common={common} />} />
      <Route path={URL_BOARD_CLASS} element={<BoardClass common={common} />} />
      <Route path={URL_BOARD_CLASS_DETAIL} element={<BoardClassDetail common={common} />} />
      <Route path={URL_BOARD_CLASS_ADD} element={<BoardClassAdd common={common} />} />
      <Route path={URL_BOARD_CLASS_EDIT} element={<BoardClassEdit common={common} />} />
      <Route path={URL_BOARD_CLASS_CAT_ADD} element={<BoardClassCateAdd common={common} />} />
      <Route path={URL_BOARD_BANNER} element={<BoardBanner common={common} />} />

      {/* 업무서식 */}
      <Route path={URL_TASK_FORM_MAIN} element={<TaskFormMain common={common} />} />
      <Route path={URL_TASK_FORM_DETAIL} element={<TaskFormDetail common={common} />} />
      <Route path={URL_TASK_FORM_ADD} element={<TaskFormAdd common={common} />} />
      <Route path={URL_TASK_FORM_EDIT} element={<TaskFormEdit common={common} />} />

      {/* 고객센터 */}
      <Route path={URL_CUSTOMER_CENTER_INQUIRY} element={<CustomerCenterInquiry common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_INQUIRY_DETAIL} element={<CustomerCenterInquiryDetail common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_FAQ} element={<CustomerCenterFaq common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_FAQ_DETAIL} element={<CustomerCenterFaqDetail common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_FAQ_ADD} element={<CustomerCenterFaqAdd common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_FAQ_EDIT} element={<CustomerCenterFaqEdit common={common} />} />
      <Route path={URL_CUSTOMER_CENTER_PRODUCT_FAQ} element={<CustomerCenterProductFaq common={common} />} />

      {/* 관리자 계정관리 */}
      <Route path={URL_ACCOUNT + URL_ADMIN_MANAGE} element={<AdminManage common={common} />} />

      {/* 조직/인사관리 */}
      <Route path={URL_ORG + URL_ORG_MANAGE} element={<OrgManage common={common} />} />
    </Routes>
  );
};

export default AdminRoute;
